import { createStore } from 'zustand-x';

export const aqiDrawerStore = createStore('aqiDrawer')(
  {
    isOpen: false,
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  openDrawer: () => {
    set.isOpen(true);
  },
  closeDrawer: () => {
    set.isOpen(false);
  },
}));
